import { ConsentPlatform, ConsentPlatformKey } from '../model/ConsentPlatform';

const deprecatedMap: Record<string, Exclude<ConsentPlatform, 'APP'>> = {
  APP: ConsentPlatform.PATIENT_APP,
};

const normalizePlatform = (type: ConsentPlatform | string): Exclude<ConsentPlatform, 'APP'> =>
  deprecatedMap[type] || ConsentPlatform[type as Exclude<ConsentPlatformKey, 'APP'>];

const isEquivalentPlatform = (typeA: ConsentPlatform | string, typeB: ConsentPlatform | string): boolean =>
  normalizePlatform(typeA) === normalizePlatform(typeB);

export const matchesPlatform = (consentPlatforms: string[], consentPlatformToFind: ConsentPlatform): boolean =>
  consentPlatforms.some(consentPlatformA => isEquivalentPlatform(consentPlatformA, consentPlatformToFind));
